import { useState, useEffect, useCallback, Fragment } from "react";
import { Table, Card, CardHeader, CardTitle,Media } from "reactstrap";
import Select from "react-select";
import { H5, H4, Btn } from "../../../../AbstractElements";
import {
  ListConsultantExpenses,
  StoreConsultantPayment,
  UpdateConsultantPayment,
} from "../../../../apiController";
import {
  Button,
  Modal,
  ModalHeader,
  CardBody,
  CardFooter,
  FormGroup,
  Label,
  Input,
  ModalBody,
  Form,
  Row,
  Col,
} from "reactstrap";
import DataTable from "react-data-table-component";
import SweetAlert from "sweetalert2";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import CloseModal from "../../../../Constant/CloseModal";

//ConsultantExpense

const ConsultantExpense = ({permission}) => {
  const [expense, setExpense] = useState([]);
  const [selectedMonthID, setSelectedMonthID] = useState(null);
  const [options, setOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [Large, setLarge] = useState(false);
  const [modal, setModal] = useState(false);
  const [details, setDetails] = useState([]);
  const [edit, setEdit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [filePreview, setFilePreview] = useState("");

  const toggleModal = () => {
    setLarge(!Large);
  };
  const toggleDoc = (doc) => {
    console.log(doc)
    setModal(!modal);
    setDetails(doc)
  };

  const toggle = (monthID) => {
    setSelectedMonthID(monthID);
    setSelectedRows([]);
    setShowDetails(!showDetails);
  };

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const type = expense
    .filter((row) => row.month === selectedMonthID && row.year === selectedYear)
    .flatMap((row) =>
      row.doctor_wise.map((doc, ind) => {
        const balance = doc.total - doc.payment.map((d) => d.already_paid);
        const date = row.date;
        const doctor = doc.data;
        const paid = doc.payment[0].already_paid;
        console.log(paid)
        return {
          ind: ind + 1,
          id: doc.doctor_id,
          doctorname: <p body className="align-self-center f-w-700 font-success" style={{ cursor: "pointer" }} onClick={()=>toggleDoc(doctor)}> {doc.doctor_name}</p>,
          doctorfee: doc.total,
          balance: balance,
          paymentStatus: doc.payment.map((d) =>
            d.status !== null ? d.status : "N/A"
          ),
          action: (
            <span key={ind} className="d-flex gap-3">
              {(balance !== 0) && permission?.create_access ? (
                <Btn
                  attrBtn={{
                    style: { width: 60, fontSize: 14, padding: 4 },
                    color: "success",
                    className: "btn btn-xs",
                    type: "button",
                    onClick: () => handleAdd(doc, date),
                  }}
                >
                  Pay
                </Btn>
              ) : null}
              {paid !== null && permission?.edit_access ? <Btn
                attrBtn={{
                  style: { width: 60, fontSize: 14, padding: 4 },
                  color: "secondary",
                  className: "btn btn-xs",
                  type: "button",
                  onClick: () => handleEdit(doc, date),
                }}
              >
                Edit
              </Btn> :  null}
            </span>
          ),
        };
      })
    );

  const monthDataColumns = [
    { name: "#", selector: (row) => row.ind, sortable: true },
    {
      name: "Doctor Name",
      selector: (row) => row.doctorname,
      sortable: true,
      center: true,
    },
    {
      name: "Doctor's Fee",
      selector: (row) => row.doctorfee,
      sortable: true,
      center: true,
    },
    {
      name: "Balance to Pay",
      selector: (row) => row.balance,
      sortable: true,
      center: true,
    },
    {
      name: "Status",
      selector: (row) => row.paymentStatus,
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      selector: (row) => row.action,
      center: true,
    },
  ];

  const tableHeader = ["#", "Month", "Total"];
  const months = [
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
  ];

  useEffect(() => {
    fetchotherExpense();
  }, []);

  const fetchotherExpense = async () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const response = await ListConsultantExpenses({month: currentMonth});
    if (response.status === true) {
      setExpense(response.monthwiseSum.reverse());
      const uniqueYears = [
        ...new Set(response.monthwiseSum.map((item) => item.year)),
      ];
      const yearOptions = uniqueYears.map((year) => ({
        value: year,
        label: year,
      }));
      setOptions(yearOptions);
    }
  };

  const handleAdd = (row, month) => {
    console.log("Add row:", row, month);
    setLarge(!Large);
    setValue("doctor_id", row.doctor_id);
    setValue("total_amount", row.total);
    setValue("month", month);
    // setValue("id", row.payment.map((d) => d.payment_id));
  };
  const handleEdit = (row, month) => {
    console.log("Edit row:", row, month);
    const rowamount = row.payment.map((d) => d.paid_amount)
    const amount = rowamount.length > 0 ? rowamount[0] : null
    const rowStatus = row.payment.map((d) => d.status)
    const status = rowStatus.length > 0 ? rowStatus[0] : null
    const doctor_id = row.doctor_id
    const paymentIds = row.payment.map((d) => d.payment_id);
    const id = paymentIds.length > 0 ? paymentIds[0] : null;
    console.log("Edit row:", amount, status, id);
    setLarge(!Large);
    setValue("doctor_id", doctor_id);
    setValue("total_amount", row.total);
    setValue("paid_amt", amount );
    setValue("status", status);
    setValue("id", id);
    setValue("month", month);
    setEdit(!edit);
  };

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log(filePreview);
    const formData = {
      id: data.id,
      doctor_id: data.doctor_id,
      total_amount: data.total_amount,
      paid_amt: data.paid_amt,
      month: data.month,
      status: data.status,
    };
    console.log(formData);

    if (!edit) {
      storeExpenses(formData);
    } 
    else
    {updateExpenses(formData)};
  };

  const storeExpenses = async (formData) => {
    setIsSubmitting(true);
    try {
      const response = await StoreConsultantPayment(formData);
      if (response.status === true) {
        toast.success("Created Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      fetchotherExpense();
      reset();
      setFilePreview("");
      setLarge(!Large);
      setIsSubmitting(false);
    }
  };

  const updateExpenses = async (formData) => {
    setIsSubmitting(true);
    try {
      const response = await UpdateConsultantPayment(formData);
      if (response.status === true) {
        toast.success("Updated Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      fetchotherExpense();
      reset();
      setFilePreview("");
      setLarge(!Large);
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {!showDetails && (
        <Card>
          <CardHeader className="d-flex gap-4 justify-content-evenly align-items-center">
            <CardTitle>Select Year</CardTitle>
            <Select
              options={options}
              className="js-example-basic-single col-sm-3"
              value={options.find((option) => option.value === selectedYear)}
              onChange={(option) => setSelectedYear(option.value)}
            />
            <H5 className="align-self-end">Consultant Payment</H5>
            {/* <button
              type="button"
              className="btn btn-primary"
              aria-hidden="true"
              onClick={toggleModal}
              style={{ cursor: "pointer", backgroundColor: "#145BD9" }}
            >
              <span className="me-1">+</span>
              Add Inventory Expenses
            </button> */}
          </CardHeader>
          <Table responsive striped>
            <thead>
              <tr className="text-center">
                {tableHeader.map((heads, i) => (
                  <th key={i}>{heads}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {months.map((data) => (
                <tr className="text-center" key={data.id}>
                  <td>{data.id}</td>
                  <td>
                  <Media body className="align-self-center f-w-700 font-info">
                    <span
                      onClick={() => toggle(data.id)}
                      style={{ cursor: "pointer" }}
                    >
                      {data.month}
                    </span>
                    </Media>
                  </td>
                  <td>
                    {expense
                      .filter(
                        (main) =>
                          main.month === data.id && main.year === selectedYear
                      )
                      .map((main, index) => (
                        <span key={index}>
                          {main.treatment_plan_method
                            ? main.treatment_plan_method
                            : "N/A"}
                        </span>
                      ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card>
      )}
      {(showDetails && !modal)  && (
        <Card>
          <CardHeader
            toggle={() => toggle(null)}
            className=" bg-light"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <span className=" bg-light ">
              Details for{" "}
              {months.find((m) => m.id === selectedMonthID)?.month || "N/A"}
            </span>
          </CardHeader>
          <CardBody>
            <Fragment>
              <DataTable
                data={type}
                columns={monthDataColumns}
                striped={true}
                center={true}
                pagination
                // selectableRows
                // onSelectedRowsChange={handleRowSelected}
                // clearSelectedRows={toggleDelet}
              />
            </Fragment>
          </CardBody>
          <CardFooter>
            <Button color="secondary" onClick={() => toggle(null)}>
              Back
            </Button>
          </CardFooter>
        </Card>
      )}

    
       {modal &&  <Card>
        <CardHeader>Consultant Fee</CardHeader>
            <CardBody>
               <Table>
                <thead>
                <tr>
                  <th>S.no</th>
                  <th>Doctor Name</th>
                  <th>Patient Name</th>
                  <th>Treatment Method</th>
                  <th>Method Fee</th>
                </tr>
                </thead>
              
                <tbody>
                  {details?.map((t, ind)=>
                  <tr>
                    <td>{ind+1}</td>
                    <td>{t.doctor_name}</td>
                    <td>{t.patient_name}</td>
                    <td>{t.treatments.map((d)=> d.treatment_method)}</td>
                    <td>{t.treatments.map((d)=> d.doctor_price)}</td>
                  </tr>
              )}
                </tbody>
              
               </Table>
              <Button onClick= {()=>setModal(!modal)}>Back</Button>

            </CardBody>
          </Card> }
      <Modal isOpen={Large} toggle={toggleModal} centered>
        <ModalHeader className="text-white bg-dark p-2 justify-content-center">
          Consultant Payment
        </ModalHeader>
        <ModalBody>
          <Card>
            <CardBody>
              <Form
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="row">
                  <div className="col-md-6 mb-sm-7 mb-4">
                    <label className="form-label">
                      <span className="required">Consultant Payment</span>
                    </label>
                    <Controller
                      name="paid_amt"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Input
                          type="number"
                          placeholder="Payment"
                          {...field}
                          className={`form-control ${
                            errors.paid_amt ? "is-invalid" : ""
                          }`}
                          onChange={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                          }}
                          required
                        />
                      )}
                    />
                    <span className="text-danger">
                      {errors.paid_amt && "Payment is required"}
                    </span>
                  </div>

                  <div className="col-md-6 mb-sm-7 mb-4">
                    <label className="form-label">
                      <span className="required">Status</span>
                    </label>
                    <Controller
                      name="status"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Input
                          type="text"
                          placeholder="Status"
                          {...field}
                          className={`form-control ${
                            errors.status ? "is-invalid" : ""
                          }`}
                          onChange={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                          }}
                          required
                        />
                      )}
                    />
                    <span className="text-danger">
                      {errors.status && "Status is required"}
                    </span>
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ width: "150px", margin: "auto", display: "block" }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
                <button
                  className="btn btn-secondary"
                  style={{ width: "150px", margin: "auto", display: "block" }}
                  onClick={toggleModal}
                >
                  {"Cancel"}
                </button>
                </div>
              </Form>

            </CardBody>
          </Card>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ConsultantExpense;
